import type { Practitioner, Questionnaire, QuestionnaireResponse } from '@medplum/fhirtypes';

import {
  validateRequiredTemplateFields,
  type QuestionnaireFillValidationResult,
} from '@/lib/questionnaireResponseFillValidation';

export type SupervisionMeetingSignValidationResult = QuestionnaireFillValidationResult;

export function validateSupervisionMeetingBeforeSign(params: {
  questionnaire: Questionnaire;
  response: Pick<QuestionnaireResponse, 'item'> | undefined;
  practitioner: Practitioner | null | undefined;
}): SupervisionMeetingSignValidationResult {
  if (!params.response) {
    return {
      success: false,
      message: 'Form is still loading. Please wait and try again.',
      missingLinkIds: [],
      missingItemPath: '',
    };
  }
  if (!params.practitioner?.id) {
    return {
      success: false,
      message: 'Your practitioner profile is not loaded. Refresh the page and try again.',
      missingLinkIds: [],
      missingItemPath: '',
    };
  }
  return validateRequiredTemplateFields(params.questionnaire, params.response);
}
